module.exports = __webpack_public_path__ + "static/media/step2_m.58ad5ca6.png";